<template>
    <input
        ref="foundationCheckbox"
        v-model="model"
        class="checkbox"
        :type="type"
        :disabled="disabled"
        :aria-disabled="disabled"
    >
    
</template>

<script setup lang="ts">
import type { FoundationCheckboxProps } from '#nuxtware/types/foundation-checkbox'

withDefaults(defineProps<FoundationCheckboxProps>(), {
    type: 'checkbox',
    disabled: false
})

const model = defineModel<boolean>()
const foundationCheckbox = ref<HTMLInputElement>()

defineExpose({ foundationCheckbox })
</script>
